import Step1 from "../../../Assets/Incident_reported.png";
import Step2 from "../../../Assets/Recovery_Team.png";
import Step4 from "../../../Assets/Inspection.png";
import Step5 from "../../../Assets/Settlement.png";
import Step6 from "../../../Assets/Back.png";

export const CHAPTERS = [
  {
    id: "step-1",
    index: "01",
    title: "INCIDENT REPORTED",
    description:
      "The moment an accident or breakdown is reported through the ClaimPro app or helpline, our platform instantly captures the vehicle location and begins the response process.",
    image: Step1,
    tag: "TELEMETRY",
  },
  {
    id: "step-2",
    index: "02",
    title: "RECOVERY TEAM DISPATCHED",
    description:
      "ClaimPro automatically identifies the nearest verified recovery partner and dispatches assistance with live tracking.",
    image: Step2,
    tag: "DISPATCH",
  },
  {
    id: "step-3",
    index: "03",
    title: "LEGAL SETTLEMENT SUPPORT",
    description:
      "Our legal partners step in early to coordinate documentation, liaise with insurers, and keep every stakeholder informed from the outset.",
    image:
      "https://images.unsplash.com/photo-1521791055366-0d553872125f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxsZWdhbCUyMGRvY3VtZW50JTIwcGVufGVufDB8fHx8MTc4NjAwNzA3NHww&ixlib=rb-4.1.0&q=85",
    tag: "LEGAL",
  },
  {
    id: "step-4",
    index: "04",
    title: "DIGITAL INSPECTION",
    description:
      "Certified surveyors perform a digital inspection using photos, videos and real-time reporting, enabling insurers to begin claim assessment immediately.",
    image: Step4,
    tag: "SURVEY",
  },
  {
    id: "step-5",
    index: "05",
    title: "WORKSHOP ASSIGNED",
    description:
      "Smart routing bypasses congested garages and assigns the vehicle to a specialized, pre-approved workshop for immediate repair.",
    image:
      "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxtZWNoYW5pYyUyMHJlcGFpcmluZyUyMGNhciUyMGdhcmFnZSUyMG5pZ2h0fGVufDB8fHx8MTc4NjAwNzA3NHww&ixlib=rb-4.1.0&q=85",
    tag: "ROUTING",
  },
  {
    id: "step-6",
    index: "06",
    title: "CLAIM SETTLEMENT SUPPORT",
    description:
      "ClaimPro finalizes the claim directly with the insurer and workshop, closing out approvals and payments on your behalf.",
    image: Step5,
    tag: "COMPLIANCE",
  },
  {
    id: "step-7",
    index: "07",
    title: "BACK ON THE ROAD",
    description:
      "Vehicle handed over. The claim is settled directly with the workshop. The user pays zero out-of-pocket for covered damages.",
    image: Step6,
    tag: "SETTLED",
  },
];